/**
 * Created by Administrador on 05/11/2018.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('findModifyValidityCtrl', findModifyValidityCtrl)
        .controller('editModifyValidityCtrl', editModifyValidityCtrl)
        .controller('modalEditPenaltyCtrl', modalEditPenaltyCtrl)
        .controller('confirmModifyValidityCtrl', confirmModifyValidityCtrl);

    findModifyValidityCtrl.$inject = ['modifyValidityService','messageService','linkService','dateService'];

    editModifyValidityCtrl.$inject = ['$stateParams', 'documentTypes', 'pnr', 'dateService', 'baseRateService', '$uibModal',
        'modifyValidityService','printService', 'linkService', 'operation', 'AuthServerProvider', 'passengerListService'];

    modalEditPenaltyCtrl.$inject = ['linkService','$uibModal','$uibModalInstance', 'baseRate', 'penalty', 'modifyValidityService'];
    confirmModifyValidityCtrl.$inject = ['$uibModalInstance', 'isValid', 'pnr'];

    function findModifyValidityCtrl(modifyValidityService, messageService, linkService,dateService){
        var vm = this;
        vm.codePnr = '';
        vm.validityDate = '';
        vm.thereIsNoPnr = false;
        vm.isReserve = false;
        vm.isValidPnr = false;

        vm.searchPnr = function(isValid){
            if(isValid){
                vm.closeError();
                modifyValidityService.getSearchPnr(vm.codePnr)
                    .then(function(res){
                        if(res[0]==undefined){
                            vm.thereIsNoPnr = true;
                        }else{
                            if(res[0].state == 'RESERVE'){
                                vm.isReserve = true;
                            }else{
                                var validityDate = dateService.getDateByDateZone(res[0].validityDate);
                                var sValidityDate = moment(validityDate).format('YYYY-MM-DD') +" 00:00:00";
                                validityDate = new Date(sValidityDate);

                                var today = new Date();
                                var sToday = moment(today).format('YYYY-MM-DD') + " 00:00:00";
                                today = new Date(sToday);
                                if(validityDate >= today){
                                    vm.validityDate = validityDate;
                                    vm.isValidPnr = true;
                                }else{
                                    linkService.reloadRoute('modifyValidityEdit', {codePnr: res[0].code});
                                }
                            }
                        }
                    });
            }
        }

        vm.closeError = function () {
            vm.thereIsNoPnr = false;
            vm.isReserve = false;
            vm.isValidPnr = false;
        }
    }

    function editModifyValidityCtrl($stateParams, documentTypes, pnr, dateService,baseRateService, $uibModal, modifyValidityService,
                                    printService, linkService, operation, AuthServerProvider, passengerListService) {
        var vm = this;
        vm.$uibModal = $uibModal;
        // vm.checkBoxPassenger[operation.codeoperation.code] = (penaltyItem.penaltyId) ? true : false;
        vm.operation = operation.data;
        vm.checkBoxPassenger = {};
        vm.baseRate = {};
        vm.pnr = getPnr(pnr);
        vm.pnrOld = angular.copy(vm.pnr);
        vm.invoiceHtml = [];
        vm.total = {
            amount: 0,
            currency: '',
            check: false
        };

        vm.cardTypes=[
            { value: 'VI', name: 'Visa' },
            { value: 'CA', name: 'Master Card' },
            { value: 'TD', name: 'Tarjeta Debito' }
        ];

        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.paymentType = {
            'paymentType': 'cash',
            'cardType': null,
            'lot': '',
            'voucher': '',
            'cardNumber': '',
            'expirationDate': '',
            'checkCard': false
        };
        vm.documentTypeList = documentTypes.data;

        getBaseRate(vm.pnr.oneWayFlight.from.id,  vm.pnr.oneWayFlight.to.id);
        pnrPassengersInit();

        function pnrPassengersInit() {
            angular.forEach(vm.pnr.passengers, function (passenger) {
                passenger.nit = null;
                passenger['disabled'] = true;
            });
        }

        vm.deletePnr = function () {
            manageReservationService.deletePnrReserve($stateParams.id)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }

        vm.eventHandlePassenger = function(){
            var j = 0;
            vm.total.amount = 0;
            vm.total.check = false;
            angular.forEach(vm.checkBoxPassenger, function (i) {
                if(i == false || i == undefined){
                    vm.pnr.passengers[j].selected = false;
                    vm.pnr.passengers[j].disabled = true;
                    vm.pnr.passengers[j].nit = null;
                    vm.pnr.passengers[j].penalties= vm.pnrOld.passengers[j].penalties;
                }else if (i == true){
                    vm.pnr.passengers[j].selected = true;
                    vm.pnr.passengers[j].disabled = false;
                    var penalty = vm.pnr.passengers[j].penalties;
                    vm.pnr.passengers[j].penalties.percentageBaseRate = (parseFloat(penalty.percentage)  * vm.baseRate.tariffBasePassage) / 100;
                    vm.pnr.passengers[j].penalties.charge.amount = parseFloat(penalty.fixAmount) + vm.pnr.passengers[j].penalties.percentageBaseRate;
                    vm.total.amount = vm.total.amount + vm.pnr.passengers[j].penalties.charge.amount;
                    vm.total.currency = vm.pnr.passengers[j].penalties.charge.currency;
                    vm.total.check = true;
                }
                j++;
            });
        }

        vm.editPenalty = function(index){
            var penalty = angular.copy(vm.pnr.passengers[index].penalties);
            vm.$uibModal.open({
                templateUrl: 'app/admin/configGeneral/modifyValidity/modalEditPenalty.html',
                controller: 'modalEditPenaltyCtrl',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    'baseRate': [function () {
                        return vm.baseRate;
                    }],
                    'penalty': [function(){
                        return penalty;
                    }]
                }
            }).result.then(function (response) {
                if(response.penalty != null){
                    vm.pnr.passengers[index].penalties = response.penalty;
                    vm.pnr.passengers[index].penalties.observation = "";
                    vm.eventHandlePassenger();
                }
            }, function () {});
        }

        vm.confirmModifyValidity = function (isValid, pnr) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/configGeneral/modifyValidity/confirmModifyValidity.html',
                controller: 'confirmModifyValidityCtrl',
                controllerAs: 'vm',
                resolve: {
                    isValid: [function () {
                        return isValid
                    }],
                    pnr: [function () {
                        return pnr
                    }]
                }
            });
            modalInstance.result.then(function (response) {
                // vm.saveModifyValidity(isValid, pnr);
                vm.saveModifyValidity(response.isValid, response.pnr);
            }, function () {
            });
        };

        vm.taxModifyValidity = function (taxes) {
            var tax = null;
            for(var i=0; i<taxes.length; i++){
                if (taxes[i].name === 'RMVP') {
                    tax = taxes[i];
                    break;
                }
            }
            return tax;
        }

        vm.saveModifyValidity =  function(isValid, pnr){
            if(isValid) {
                if (validMonthYear()) {
                    var passengersNew = [];
                    var passengersOld = [];
                    for(var i=0; i<pnr.passengers.length; i++){
                        if(pnr.passengers[i].selected){
                            for(var j=0; j<pnr.passengers[i].rti.length; j++){
                                var rtiPassenger = pnr.passengers[i].rti[j];
                                if(!rtiPassenger.returned){
                                    var tax = vm.taxModifyValidity(rtiPassenger.selectedFare.fares[0].tax);
                                    var penalty = pnr.passengers[i].penalties;
                                    if (tax !== null) {
                                        tax.fisicalCredit = penalty.fisicalCredit;
                                        tax.fixAmount = penalty.fixAmount;
                                        tax.name = penalty.name;
                                        tax.penalty = penalty.penalty;
                                        tax.percentage = penalty.percentage;
                                        tax.willByPaid = penalty.willByPaid;
                                        tax.charge.amount = penalty.charge.amount;
                                        tax.charge.currency = penalty.charge.currency;
                                    } else {
                                        rtiPassenger.selectedFare.fares[0].tax.push(pnr.passengers[i].penalties);
                                    }
                                    rtiPassenger.invoice = false;
                                    rtiPassenger.interruption = false;

                                    angular.forEach(rtiPassenger.rtiConnections, function (rtiConnection) {
                                        rtiConnection.used = true;
                                    });

                                    passengersNew.push(pnr.passengers[i]);
                                }
                            }
                        }else{
                            passengersOld.push(pnr.passengers[i]);
                        }
                        if(vm.paymentType.paymentType=='cash'){
                            pnr.payment.type = 'EFFECTIVE';
                            pnr.payment.total = vm.total.amount;
                        }else{
                            pnr.payment.type = 'POS';
                            pnr.payment.total = vm.total.amount;
                            pnr.payment.card = vm.paymentType.cardType;
                            pnr.payment.cardNumber = vm.paymentType.cardNumber;
                            pnr.payment.expiration = vm.paymentType.expirationDate;
                            pnr.payment.lot = vm.paymentType.lot;
                            pnr.payment.voucher = vm.paymentType.voucher;
                        }
                    }
                    pnr.state ='EXTENSION_VALID_DATE';
                    pnr.passengers = passengersNew;
                    pnr.agent = null;
                    vm.pnrOld.passengers = passengersOld;
                    vm.pnrOld.agent = null;

                    var operationSale = {
                         "change": pnr,
                         "origin": passengersOld.length == 0 ? null : vm.pnrOld,
                         "pnrCode": pnr.ticketNumber,
                         "split": passengersOld.length == 0 ? false : true,
                         "typeOperation": "SOLD_EXTENSION_VALID_DATE"
                     };
                    //var originPassengerTypes = passengerListService.getCountPassengersType(operationSale.origin.passengers);
                    var changePassengerTypes = passengerListService.getCountPassengersType(operationSale.change.passengers);
                    //passengerListService.updateFlightPassengerTypes(operationSale.origin, originPassengerTypes);
                    passengerListService.updateFlightPassengerTypes(operationSale.change, changePassengerTypes);

                    if(passengersOld.length !== 0){
                        var originPassengerTypes = passengerListService.getCountPassengersType(operationSale.origin.passengers);
                        passengerListService.updateFlightPassengerTypes(operationSale.origin, originPassengerTypes);
                    }

                    modifyValidityService.updateExtensionValidDate(operationSale, vm.userAccount.userName)
                        .then(function(response){
                            vm.invoiceHtml = response.data.invoiceHtml;
                            if(response.data.invoiceHtml != undefined){
                                setTimeout(function(){
                                    printService.print('invoiceHtml');
                                    linkService.reloadRoute('modifyValidity');
                                },300);
                            }
                        });
                }
            }
        }

        function validMonthYear(){
            var res = false;
            var month = vm.paymentType.month;
            var year = vm.paymentType.year;
            var expirationDate = '';

            if(vm.paymentType.paymentType=='card') {
                if (year.length === 2) {
                    if (parseInt(year) >= 19) {
                        if (parseInt(month) >= 1 && parseInt(month) <= 12) {
                            var day = getLastDay(month);
                            expirationDate = (parseInt(year) + 2000) + "-" + ((month).length == 1 ? ("0" + month) : month) + "-" + day;
                            var parseExpirationDate = new Date(expirationDate);
                            var now = new Date();
                            if (parseExpirationDate.getTime() > now.getTime()) {
                                vm.paymentType.expirationDate = parseExpirationDate;
                                res = true;
                            } else {
                                vm.paymentType.month = '';
                                res = false;
                            }
                        } else {
                            vm.paymentType.month = '';
                            res = false;
                        }
                    } else {
                        vm.paymentType.year = '';
                        res = false;
                    }
                }
            }else{
                res = true;
            }
            return res;
        }

        function getLastDay(mesv){
            var res = 0;
            var arrayMeses=new Array('31','28','31','30','31','30','31','31','30','31','30','31');
            if(mesv.substring(0,1) == "0"){
                mesv=parseInt(mesv.substring(1));
            }else{
                mesv=parseInt(mesv);
            }
            for(var i=1 ; i<=12 ; i++){
                if(i==mesv){
                    res = arrayMeses[i-1];
                    break;
                }
            }
            return res;
        }

        vm.changePaymentType = function (type) {
            vm.paymentType.lot = '';
            vm.paymentType.voucher = '';
            vm.paymentType.cardNumber = '';
            vm.paymentType.expirationDate = '';
            vm.paymentType.cardType = null;

            if(type=='cash'){
                vm.paymentType.checkCard = false;
            }else{
                vm.paymentType.checkCard = true;
            }
        }

        vm.changeDocumentType = function (index) {
            if (vm.pnr.passengers[index].documentTypeId != null) {
                vm.pnr.passengers[index].nit = null;
                vm.pnr.passengers[index].complement = null;
                vm.pnr.passengers[index].documentType = vm.pnr.passengers[index].documentTypeId.id;
            }
        }

        function getPnr(pnr){
            pnr.oneWayFlight = null;
            pnr.returnFlight = null;
            pnr.emissionLimit = dateService.getDateByDateZone(pnr.emissionLimit);
            pnr.observation = "";
            pnr.payment = {
                authorizationCode: 0,
                brand: "",
                clientIdClient: 0,
                currencyIdCurrency: 0,
                date: "",
                errorCode: 0,
                gcp: 0,
                idPayment: 0,
                paymentReference: "",
                referenceId: 0,
                serviceIdService: 0,
                status: "",
                total: 0,
                type: "EFFECTIVE"
            }

            angular.forEach(pnr.flights, function(flight){
                if(flight.returned){
                    pnr.returnFlight = flight;
                }else{
                    pnr.oneWayFlight = flight;
                }
            })

            angular.forEach(pnr.passengers, function(passenger){
                passenger.selected = false;
                passenger.comments = "";
                passenger.socialReason = null;
                passenger.documentType = null;
                passenger.documentTypeId = null;
                passenger.complement = null;
                passenger.nit = null;
                angular.forEach(passenger.rti, function(rti){
                    if(!rti.returned){
                        rti.selectedFare.fares[0].tax
                        var bandIsEnabled = false;
                        angular.forEach(rti.selectedFare.fares[0].tax, function(tax){
                            if(tax.name=="RMVP"){
                                passenger.penalties = {
                                    charge: {
                                        amount: 0,
                                        currency: "BOB",
                                        toAmount: 0,
                                        toCurrency: " ---",
                                        exchangeRate: 1,
                                        percentageBaseRate: 0
                                    },
                                    fiscalCredit: false,
                                    fixAmount: parseFloat(tax.fixAmount),
                                    id: 0,
                                    name: "RMVP",
                                    penalty: true,
                                    percentage: parseFloat(tax.percentage),
                                    willByPaid: true
                                }
                                bandIsEnabled = true;
                            }
                        });
                        passenger.enabled = bandIsEnabled;
                    }
                });
                vm.checkBoxPassenger[passenger.passengerPnrId] = false;
            });
            return pnr;
        }

        function getBaseRate(airportOriginId, airportDestinyId){
            baseRateService.getBaseRateByOriginDestiny(airportOriginId, airportDestinyId)
                .then(function(response){
                    vm.baseRate = response.data;
                });

        }
    }

    function confirmModifyValidityCtrl($uibModalInstance, isValid, pnr){
        var vm = this;
        vm.pnr = pnr;

        vm.confirmModify = function(){
            $uibModalInstance.close({isValid: isValid, pnr: pnr});
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function modalEditPenaltyCtrl(linkService, $uibModal, $uibModalInstance, baseRate, penalty, modifyValidityService) {
        var vm = this;
        vm.penalty = penalty;
        vm.baseRate = baseRate;

        vm.closeDialog = function (response) {
            $uibModalInstance.close(response);
        }

        vm.cancel = function () {
            $uibModalInstance.close({penalty: null});
        }

        vm.modifyPenalty = function(){
            vm.penalty.percentageBaseRate = (parseFloat(vm.penalty.percentage) * vm.baseRate.tariffBasePassage) / 100;
            vm.penalty.charge.amount = parseFloat(vm.penalty.fixAmount) + vm.penalty.percentageBaseRate;
        }

        vm.editPenalty = function(isValid) {
            if (isValid) {
                var save = {
                    "code": 'ADV',
                    "fixAmount": vm.penalty.fixAmount,
                    "percentage": vm.penalty.percentage,
                    "total": vm.penalty.charge.amount,
                    "taxPenalty": 0,
                    "observation": vm.penalty.observation
                }
                modifyValidityService.saveModifyValidity(save)
                    .then(function (result) {
                        if(result == "error"){
                            vm.closeDialog({penalty: null});
                        }else{
                            vm.closeDialog({penalty: vm.penalty});
                        }
                    });

            }
        }
        /*vm.assignAirCrewForm = {};
        vm.assignAirCrew = [];
        vm.$uibModal = $uibModal;
        vm.occupationCrewService = occupationCrewService;
        vm.modelAircrafts = modelAirCrafts.data._embedded.modelAircrafts;
        vm.isModal = isModal;

        vm.crew = {
            typeCrew: typeCrew
        };

        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: false
            },
            closed: function (args) {
                var valueDate = args.closeDate;
                vm.datepickerTo.datepickerOptions.minDate = valueDate;
            }
        };

        vm.datepickerTo = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };
        // CALENDAR ================================================================

        vm.closeDialog = function (response) {
            $uibModalInstance.close(response);
        }

        vm.saveAddNewCrew = function(isValid) {
            var save = {
                "name": vm.crew.name,
                "lastName": vm.crew.lastName,
                "nroIdentity": vm.crew.nroIdentity,
                "address": vm.crew.address,
                "phone": vm.crew.phone,
                "license": vm.crew.license,
                "expirationDate": moment(vm.crew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": 1,
                "modelAircraftId":  vm.crew.modeAirCraft.modelAircraftId,
                "makerId":  vm.crew.modeAirCraft.makerId,
                "typeCrew": vm.crew.typeCrew
            }

            if (isValid) {
                airCrewService.saveAddAirCrew(save)
                    .then(function (result) {
                        vm.closeDialog({airCrew: result.data});
                    });
            }
        }

        vm.saveAirCrew = function (isValid, airCrew) {
            var save = {
                "name": airCrew.name,
                "lastName": airCrew.lastName,
                "nroIdentity": airCrew.nroIdentity,
                "address": airCrew.address,
                "phone": airCrew.phone,
                "license": airCrew.license,
                "expirationDate": moment(airCrew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": 1,
                "modelAircraftId":  airCrew.modeAirCraft.modelAircraftId,
                "makerId":  airCrew.modeAirCraft.makerId,
                "typeCrew": airCrew.typeCrew
            }

            if (isValid) {
                airCrewService.saveAirCrew(save)
                    .then(function (result) {
                        vm.closeDialog();
                    });
            }
        }*/
    }
})();
